import { Link } from 'react-router-dom'

import Container from '../ui/Container'
import Logo from '../ui/Logo'
import { businessInfo } from '../../data/site'

import './index.css'

const quickLinks = [
  { name: 'Home', href: '/' },
  { name: 'Our Services', href: '/services' },
  { name: 'About Us', href: '/about' },
  { name: 'Contact Us', href: '/contact' },
]

function Footer() {
  const year = new Date().getFullYear()

  return (
    <div className="w-full bg-primary-900 text-primary-100 text-sm">
      <Container className="py-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          <div>
            <Logo light />
            <p className="text-primary-200 text-xs mt-3">
              Quality-driven diagnostic care in Ikorodu and Ogijo, serving Lagos and Ogun State.
            </p>
          </div>
          <div>
            <p className="text-white font-semibold mb-2">Quick Links</p>
            <ul className="space-y-1">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="hover:text-white transition-colors">{link.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-white font-semibold mb-2">Contact</p>
            <p className="text-xs">{businessInfo.phones.join(' | ')}</p>
            <p className="text-xs mt-1">{businessInfo.email}</p>
          </div>
        </div>
      </Container>
      <div className="border-t border-primary-800">
        <Container className="py-4 flex flex-col sm:flex-row justify-center text-center gap-1 text-xs">
          <span>Copyright &copy; {year} {businessInfo.name} — All rights reserved.</span>
          &nbsp;
          <span>Designed by <span className="footer-designed-by">Nwosu Onyedikachi</span></span>
        </Container>
      </div>
    </div>
  )
}

export default Footer
